"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeRenderer = void 0;
exports.DateTimeControl = DateTimeControl;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_2 = require("@jsonforms/react");
const antd_1 = require("antd");
const dayjs_1 = __importDefault(require("dayjs"));
const ui_schema_1 = require("../ui-schema");
function getOverrides(options) {
    if ((0, ui_schema_1.isDateTimeControlOptions)(options)) {
        return options;
    }
    return {};
}
function getInitialValue(data, schemaDefault) {
    if (typeof data === "string" && data !== "") {
        return data;
    }
    if (typeof schemaDefault === "string" && schemaDefault !== "") {
        return schemaDefault;
    }
    return undefined;
}
function DateTimeControl({ handleChange, path, label, id, required, schema, uischema, visible, data, }) {
    const setInitialValue = (0, react_1.useCallback)((value) => {
        const coercedValue = value ? (0, dayjs_1.default)(value) : value;
        handleChange(path, value);
        return coercedValue;
    }, [handleChange, path]);
    const form = antd_1.Form.useFormInstance();
    (0, react_1.useEffect)(() => {
        form.setFieldValue(path, setInitialValue(getInitialValue(data, schema.default)));
    }, [data, form, path, schema.default, setInitialValue]);
    if (!visible)
        return null;
    const rules = [{ required, message: `${label} is required` }];
    const formItemProps = "formItemProps" in uischema ? uischema.formItemProps : {};
    const overrides = getOverrides(uischema.options);
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: label, id: id, name: path, required: required, validateTrigger: ["onBlur"], rules: rules, ...formItemProps, children: (0, jsx_runtime_1.jsx)(antd_1.DatePicker, { format: "YYYY-MM-DDTHH:mm:ssZ", onChange: (_, dateString) => handleChange(path, dateString), ...overrides }) }));
}
exports.DateTimeRenderer = (0, react_2.withJsonFormsControlProps)((0, react_1.memo)(DateTimeControl));
